import { formatIdr, useLinkPricing } from "../lib/pricing";

type LegalSection = {
  title: string;
  paragraphs: string[];
  bullets?: string[];
  closing?: string;
};

export default function TermsPage() {
  const linkPriceLabel = formatIdr(useLinkPricing());
  const sections: LegalSection[] = [
  {
    title: "1. Tentang layanan",
    paragraphs: [
      "RupaPreview adalah layanan untuk membuat simulasi tampilan carousel dan, melalui fitur berbayar, mengekspornya menjadi preview link yang dapat dibuka tanpa login.",
      `Pembuatan dan pengeditan draft di editor dapat digunakan secara gratis. Biaya ${linkPriceLabel} dikenakan untuk setiap export preview link yang berhasil dibuat. RupaPreview tidak menggunakan langganan, kredit, paket koin, saldo prabayar, atau top-up.`,
      "Harga dan total pembayaran ditampilkan sebelum pengguna menyelesaikan transaksi.",
    ],
  },
  {
    title: "2. Akun dan pembayaran",
    paragraphs: [
      "Login Google diperlukan untuk export berbayar agar transaksi dan Recent Links dapat dikaitkan dengan akun pengguna, serta untuk membantu pemulihan dan pemeriksaan apabila terjadi kendala.",
      "Pembayaran dilakukan melalui QR dan diproses oleh penyedia layanan pembayaran. Status pembayaran harus terverifikasi oleh sistem sebelum export diproses. Halaman sukses, tangkapan layar pembayaran, atau pengalihan dari halaman pembayaran saja tidak dianggap sebagai bukti bahwa transaksi telah terverifikasi.",
      "Pengguna bertanggung jawab menjaga akses ke akunnya dan memastikan informasi yang digunakan untuk transaksi adalah benar.",
    ],
  },
  {
    title: "3. Kepemilikan dan izin atas konten",
    paragraphs: [
      "Pengguna tetap memiliki hak atas konten yang diunggahnya.",
      "Pengguna memberikan izin terbatas kepada RupaWorks untuk menyimpan, memproses, menampilkan, dan menyediakan konten tersebut melalui preview link hanya sejauh diperlukan untuk menjalankan layanan. RupaWorks tidak mengambil alih kepemilikan konten dan tidak menggunakannya untuk materi promosi tanpa persetujuan terpisah.",
    ],
    bullets: [
      "Pengguna adalah pemilik konten atau telah memperoleh izin yang diperlukan.",
      "Pengguna telah memperoleh persetujuan dari pihak yang berhak apabila konten memuat identitas, karya, atau materi milik pihak lain.",
      "Penggunaan konten tidak melanggar hukum, hak privasi, hak kekayaan intelektual, atau hak pihak lain.",
    ],
  },
  {
    title: "4. Tanggung jawab atas konten",
    paragraphs: [
      "RupaPreview menyediakan sarana pembuatan dan penayangan preview berdasarkan materi dari pengguna. RupaWorks tidak melakukan pemeriksaan menyeluruh atau moderasi proaktif terhadap setiap konten sebelum ditayangkan.",
      "Pengguna bertanggung jawab atas konten yang diunggah, keputusan untuk menayangkannya, serta pihak yang menerima linknya. Pengguna juga bertanggung jawab atas klaim atau kerugian pihak ketiga yang timbul secara langsung dari konten tersebut atau dari pelanggaran ketentuan ini oleh pengguna, sepanjang diizinkan oleh hukum.",
      "Ketentuan ini tidak menghapus tanggung jawab RupaWorks atas pengelolaan layanan atau kewajiban lain yang tidak dapat dikesampingkan berdasarkan hukum.",
    ],
  },
  {
    title: "5. Konten dan penggunaan yang dilarang",
    paragraphs: ["Pengguna tidak boleh menggunakan RupaPreview untuk mengunggah, menayangkan, atau menyebarkan konten yang:"],
    bullets: [
      "Melanggar hukum atau mendorong tindakan melawan hukum.",
      "Mengandung pornografi anak, eksploitasi, kekerasan seksual, atau pelanggaran terhadap anak.",
      "Melanggar privasi, mengancam, melecehkan, atau mencemarkan nama baik pihak lain.",
      "Melanggar hak cipta, merek, atau hak kekayaan intelektual lainnya.",
      "Digunakan untuk penipuan, phishing, manipulasi transaksi, atau penyamaran identitas.",
      "Memuat data pribadi pihak lain tanpa dasar atau izin yang sah.",
      "Mengganggu, merusak, atau mencoba memperoleh akses tidak sah ke layanan maupun sistem pihak lain.",
    ],
    closing: "RupaWorks dapat membatasi akses, menghapus konten atau link, menonaktifkan export, atau membatasi penggunaan akun apabila terdapat pelanggaran, laporan yang patut diverifikasi, risiko keamanan, permintaan resmi, atau kewajiban hukum. Jika memungkinkan dan tidak dilarang hukum, RupaWorks akan memberikan penjelasan mengenai tindakan tersebut.",
  },
  {
    title: "6. Sifat preview link",
    paragraphs: [
      "Preview link bersifat unlisted, bukan privat atau terenkripsi end-to-end. Link tidak ditampilkan dalam direktori publik RupaWorks, tetapi dapat dibuka oleh siapa pun yang memperoleh URL-nya tanpa login.",
      "Pengguna bertanggung jawab atas pembagian URL. RupaWorks tidak bertanggung jawab atas penyebaran ulang link oleh penerima, sepanjang penyebaran tersebut bukan disebabkan oleh pelanggaran keamanan atau kelalaian RupaWorks.",
      "Sample atau demo resmi yang disediakan RupaWorks dapat bersifat permanen. Sample tersebut bukan hasil export pelanggan dan tidak mengubah masa aktif link pelanggan.",
    ],
  },
  {
    title: "7. Masa aktif, penyimpanan, dan penghapusan",
    paragraphs: [
      "Preview link pelanggan aktif selama 14 hari sejak export berhasil. Recent Links menampilkan link selama masih berada dalam periode aktifnya.",
      "Setelah periode tersebut berakhir, link kedaluwarsa dan tidak lagi dapat diakses. Aset dan preview pelanggan dijadwalkan untuk dihapus dari penyimpanan melalui proses pembersihan sistem. Link tidak dapat diperpanjang atau dipulihkan setelah asetnya dihapus.",
      "RupaPreview bukan layanan backup atau penyimpanan permanen. Pengguna wajib menyimpan salinan asli dan hasil yang masih dibutuhkan.",
      "Penghapusan aset dan preview tidak berarti seluruh data akun atau transaksi dihapus. Informasi akun, catatan pembayaran, persetujuan ketentuan, log keamanan, serta catatan penanganan keluhan dapat disimpan lebih lama sepanjang diperlukan untuk operasional, keamanan, penyelesaian sengketa, atau kewajiban hukum.",
    ],
  },
  {
    title: "8. Gangguan teknis dan pengembalian dana",
    paragraphs: ["Pengembalian dana dapat diajukan apabila:"],
    bullets: [
      "Pembayaran telah terverifikasi, tetapi preview link gagal dibuat karena kesalahan teknis RupaWorks.",
      "Preview link berhasil dibuat tetapi tidak dapat digunakan sebagaimana ditawarkan karena kesalahan teknis RupaWorks.",
    ],
    closing: "Pengguna dapat menghubungi hallo@rupaworks.com dengan menyertakan alamat email akun, waktu transaksi, ID order jika tersedia, dan deskripsi kendala. RupaWorks akan memeriksa catatan pembayaran dan sistem, lalu dapat terlebih dahulu berupaya memulihkan layanan. Apabila kegagalan terverifikasi dan tidak dapat dipulihkan dalam waktu yang wajar, pengembalian dana akan diproses sesuai nilai transaksi yang relevan serta prosedur penyedia pembayaran. Pengembalian dana tidak berlaku apabila layanan telah diberikan sesuai ketentuan, termasuk apabila kendala disebabkan oleh perubahan pikiran, kesalahan memilih atau mengunggah konten, perangkat atau koneksi pengguna, link yang telah kedaluwarsa, penyebaran link oleh pengguna, atau penghapusan akibat pelanggaran ketentuan. Ketentuan ini tidak membatasi hak konsumen yang secara wajib diberikan oleh hukum.",
  },
  {
    title: "9. Ketersediaan layanan dan pihak ketiga",
    paragraphs: [
      "RupaWorks berupaya menjaga layanan tetap tersedia, tetapi tidak menjamin bahwa layanan akan selalu bebas dari gangguan, keterlambatan, pemeliharaan, atau kesalahan.",
      "RupaPreview bergantung pada layanan pihak ketiga, termasuk Google untuk autentikasi dan penyedia layanan pembayaran untuk transaksi QR. Penggunaan layanan tersebut juga tunduk pada ketentuan masing-masing penyedia.",
      "Gangguan pihak ketiga tidak otomatis dianggap sebagai kelalaian RupaWorks. Namun, RupaWorks tetap akan membantu melakukan verifikasi dan penanganan apabila gangguan tersebut memengaruhi transaksi atau export.",
    ],
  },
  {
    title: "10. Batasan tanggung jawab",
    paragraphs: ["Sepanjang diizinkan oleh hukum:"],
    bullets: [
      "RupaWorks tidak bertanggung jawab atas kerugian tidak langsung, kehilangan kesempatan, kehilangan keuntungan, atau kerugian yang bukan merupakan akibat langsung dan wajar dari pelanggaran RupaWorks.",
      "Total tanggung jawab RupaWorks terkait suatu transaksi berbayar dibatasi pada jumlah yang dibayarkan pengguna untuk transaksi tersebut.",
      "Pengguna tetap memiliki hak serta RupaWorks tetap memiliki kewajiban yang menurut hukum tidak dapat dibatasi atau dikesampingkan.",
    ],
    closing: "Ketentuan ini tidak berlaku untuk mengecualikan tanggung jawab atas penipuan, kesengajaan, atau bentuk tanggung jawab lain yang tidak dapat dikesampingkan berdasarkan hukum.",
  },
  {
    title: "11. Laporan konten, dukungan, dan keluhan",
    paragraphs: [
      "Laporan konten, pertanyaan transaksi, permintaan bantuan, dan keluhan dapat dikirim ke hallo@rupaworks.com. Gunakan subject Dukungan, Pembayaran, atau Laporan Konten agar pesan lebih mudah ditangani.",
      "Untuk laporan konten, sertakan URL yang dilaporkan, alasan laporan, dan bukti atau penjelasan yang relevan. RupaWorks dapat meminta informasi tambahan untuk memverifikasi laporan dan mencegah penyalahgunaan proses pelaporan.",
      "Para pihak diutamakan menyelesaikan keluhan melalui komunikasi dan musyawarah dengan itikad baik. Ketentuan ini tidak menghalangi pengguna atau RupaWorks menggunakan jalur penyelesaian yang disediakan hukum.",
    ],
  },
  {
    title: "12. Masukan dan saran",
    paragraphs: [
      "Masukan dan saran bersifat sukarela. RupaWorks dapat menggunakan masukan tersebut untuk mengevaluasi dan mengembangkan layanan tanpa kewajiban untuk menerapkan setiap usulan atau memberikan kompensasi.",
      "Pengguna tidak perlu mengirimkan informasi rahasia, kredensial, atau data pribadi yang tidak diperlukan. Alamat email yang diberikan secara opsional hanya digunakan untuk menindaklanjuti masukan tersebut.",
      "Masukan disimpan selama 90 hari sejak pengiriman, kecuali penanganannya masih berjalan atau penyimpanan lebih lama diperlukan untuk kewajiban hukum dan keamanan.",
    ],
  },
  {
    title: "13. Privasi",
    paragraphs: [
      "RupaWorks memproses informasi yang diperlukan untuk menyediakan layanan, seperti informasi akun Google yang diverifikasi, konten yang diunggah, catatan transaksi, serta log keamanan dan operasional.",
      "Data digunakan untuk autentikasi, pembuatan dan penyimpanan preview, verifikasi pembayaran, penyediaan Recent Links, pencatatan persetujuan ketentuan, pencegahan penyalahgunaan, dukungan pengguna, dan pemenuhan kewajiban hukum.",
      "Permintaan terkait akses, koreksi, atau penghapusan data dapat diajukan melalui hallo@rupaworks.com, dengan tetap memperhatikan retensi yang diperlukan untuk transaksi, keamanan, sengketa, dan kewajiban hukum.",
    ],
  },
  {
    title: "14. Perubahan ketentuan",
    paragraphs: [
      "RupaWorks dapat memperbarui ketentuan ini untuk mencerminkan perubahan layanan atau kewajiban hukum. Tanggal pembaruan akan ditampilkan pada halaman ketentuan.",
      "Perubahan tidak berlaku surut untuk mengurangi manfaat transaksi yang telah dibayar, kecuali disepakati pengguna atau diwajibkan oleh hukum.",
      "Ketentuan ini ditafsirkan berdasarkan hukum Republik Indonesia.",
    ],
  },
];

  return (
    <main className="legal-page">
      <header className="legal-header">
        <a className="brand" href="/" aria-label="RupaPreview home">
          <img className="brand-logo" src="/rupaworks-logo.png" alt="Rupaworks" />
          <span className="brand-divider" aria-hidden="true" />
          <span className="brand-product"><span>Rupa</span><strong>Preview</strong></span>
        </a>
        <a className="legal-header__back" href="/">Back to editor ↑</a>
      </header>
      <article className="legal-article">
        <div className="legal-hero">
          <span className="section-kicker">KETENTUAN & PRIVASI</span>
          <h1>Ketentuan Layanan RupaPreview</h1>
          <p>RupaWorks, dioperasikan oleh PT RUPAWORKS (PERSEORANGAN).</p>
          <dl>
            <div><dt>Terakhir diperbarui</dt><dd>27 Oktober 2026</dd></div>
            <div><dt>Versi</dt><dd>2026-10-27</dd></div>
            <div><dt>Kontak</dt><dd><a href="mailto:hallo@rupaworks.com">hallo@rupaworks.com</a></dd></div>
          </dl>
          <p>Dengan menggunakan RupaPreview, pengguna menyetujui ketentuan ini. Jika pengguna tidak menyetujui ketentuan ini, pengguna dapat berhenti menggunakan layanan dan tidak melanjutkan pembayaran.</p>
        </div>
        <div className="legal-sections">
          {sections.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.bullets && <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>}
              {section.closing && <p>{section.closing}</p>}
            </section>
          ))}
        </div>
      </article>
      <footer className="legal-footer">
        <span>RupaPreview by Rupaworks. © 2026 PT RUPAWORKS.</span>
        <span><a href="/">RupaPreview</a><a href="/terms">Terms &amp; Privacy</a><a href="https://seller.rupaworks.com/">RupaSeller ↗</a></span>
      </footer>
    </main>
  );
}
